// Color constants
export const COLORS = {
  red: {
    base: "#FF4D4F",
    light: "#FFF1F0",
    dark: "#CF1322",
  },
  yellow: {
    base: "#FFC107",
    light: "#FFF7E6",
    dark: "#D48806",
  },
  green: {
    base: "#4CAF50",
    light: "#F6FFED",
    dark: "#389E0D",
  },
};

// Application theme colors
export const themeColors = {
  primary: "#131d80",
  primaryHover: "#202EC6",
  secondary: "#4A5568",
  accent: "#3182CE",
  neutral: "#718096",
};

// Standard card styling
export const cardStyles = {
  // Base card style
  cardClass:
    "bg-white dark:bg-neutral-800 rounded-lg shadow-sm hover:shadow-lg dark:hover:shadow-none transition-shadow duration-200 p-6 border border-neutral-200 dark:border-neutral-700",

  // Hover-up effect for cards
  hoverUpClass: "transition-transform duration-200 hover:translate-y-[-2px]",

  // Card header styling
  cardHeaderClass: "flex items-center mb-4",

  // Card title styling
  cardTitleClass: "text-lg font-semibold text-neutral-900 dark:text-neutral-100",

  // Card gradient background
  cardGradient: "bg-gradient-to-b from-blue-50 to-white dark:bg-neutral-800 dark:from-transparent dark:to-transparent",
};

// Maps a score (0-100) to a color gradient
export const getScoreGradient = (score) => {
  if (score >= 90) {
    return {
      background: "from-emerald-50 via-green-50 to-white",
      progress: "bg-emerald-500",
      hover: "group-hover:bg-emerald-600",
      text: "text-emerald-700",
    };
  } else if (score >= 75) {
    return {
      background: "from-green-50 via-lime-50 to-white",
      progress: "bg-green-500",
      hover: "group-hover:bg-green-600",
      text: "text-green-700",
    };
  } else if (score >= 60) {
    return {
      background: "from-lime-50 via-yellow-50 to-white",
      progress: "bg-lime-500",
      hover: "group-hover:bg-lime-600",
      text: "text-lime-700",
    };
  } else if (score >= 45) {
    return {
      background: "from-yellow-50 via-yellow-50 to-white",
      progress: "bg-yellow-500",
      hover: "group-hover:bg-yellow-600",
      text: "text-yellow-700",
    };
  } else if (score >= 30) {
    return {
      background: "from-orange-50 via-yellow-50 to-white",
      progress: "bg-orange-500",
      hover: "group-hover:bg-orange-600",
      text: "text-orange-700",
    };
  } else if (score >= 15) {
    return {
      background: "from-red-50 via-orange-50 to-white",
      progress: "bg-red-500",
      hover: "group-hover:bg-red-600",
      text: "text-red-700",
    };
  } else {
    return {
      background: "from-red-100 via-red-50 to-white",
      progress: "bg-red-600",
      hover: "group-hover:bg-red-700",
      text: "text-red-800",
    };
  }
};

// Get priority-based colors for tasks
export const getPriorityColors = (priority) => {
  switch (priority.toLowerCase()) {
    case "urgent":
      return {
        bg: "bg-red-100",
        text: "text-red-800",
        border: "bg-red-500",
      };
    case "deadline upcoming":
      return {
        bg: "bg-yellow-100",
        text: "text-yellow-800",
        border: "bg-yellow-500",
      };
    case "recommended":
      return {
        bg: "bg-blue-100",
        text: "text-blue-800",
        border: "bg-blue-500",
      };
    default:
      return {
        bg: "bg-gray-100",
        text: "text-gray-800",
        border: "bg-gray-500",
      };
  }
};

// Get gradient classes for card backgrounds
export const getCardGradient = (type) => {
  switch (type) {
    case "risk":
      return "bg-gradient-to-br from-orange-50 to-red-50 dark:bg-neutral-800 dark:from-transparent dark:to-transparent";
    case "health":
      return "bg-gradient-to-br from-green-50 to-blue-50 dark:bg-neutral-800 dark:from-transparent dark:to-transparent";
    case "neutral":
      return "bg-gradient-to-br from-gray-50 to-white dark:bg-neutral-800 dark:from-transparent dark:to-transparent";
    case "primary":
      return "bg-gradient-to-br from-blue-50 to-indigo-50 dark:bg-neutral-800 dark:from-transparent dark:to-transparent";
    default:
      return "bg-white dark:bg-neutral-800";
  }
};

// Button gradient classes
export const buttonGradients = {
  primary: "bg-[#131d80] hover:bg-[#202EC6] dark:bg-[#202EC6] dark:hover:bg-[#2A3BE0]",
  success:
    "bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 dark:from-green-700 dark:to-green-800 dark:hover:from-green-800 dark:hover:to-green-900",
  danger:
    "bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 dark:from-red-700 dark:to-red-800 dark:hover:from-red-800 dark:hover:to-red-900",
  warning:
    "bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 dark:from-yellow-600 dark:to-yellow-700 dark:hover:from-yellow-700 dark:hover:to-yellow-800",
};
